import { render, staticRenderFns } from "./DifficultyLevels.vue?vue&type=template&id=610cfd66&scoped=true&"
import script from "./DifficultyLevels.vue?vue&type=script&lang=js&"
export * from "./DifficultyLevels.vue?vue&type=script&lang=js&"
import style0 from "./DifficultyLevels.vue?vue&type=style&index=0&id=610cfd66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610cfd66",
  null
  
)

export default component.exports